export function trimPresignedUrl(url: string): string {
  return url.split('?')[0];
}
